package com.cybergstudios.rtc.math

import kotlin.math.sqrt

data class Vec2(var x: Double, val y: Double) {
    fun scale(f: Double): Vec2 = Vec2(x * f, y * f)
    fun add(v: Vec2): Vec2 = Vec2(x + v.x, y + v.y)
    fun magnitude(): Double = sqrt(x * x + y * y)
}
